import { useContext, useEffect, useRef, useState } from 'react';
import { validateFormField } from '../Core/FormFieldValidation';
import { SmartContext } from '../Core/SmartContext';
import { evaluateExpression, getControlValueFromState, handleControlValueChange, isEmpty } from '../Core/SmartFunctions';
import { SimpleFormControlArguments, State } from '../Core/SmartTypes';
import ErrorControl from './ErrorControl';
import AsyncSelect from 'react-select/async';
// import SessionContext from '../Core/SessionContext';
import { axiosClient } from '../Service/axiosClient';

const AutoCompleteControl = (args: SimpleFormControlArguments) => {
    const { state, dispatch } = useContext(SmartContext);
    // const { sessionState } = useContext(SessionContext);
    const { control, dataKey, parentDataKey } = { ...args };
    const data = getControlValueFromState(dataKey, state as State);

    const [selectedOptions, setSelectedOptions] = useState<any[]>([]);
    // const [selectedId, setSelectedId] = useState('');

    const apiParamList = control.props?.customProperties?.params || [];
    const apiParams: any = {};

    apiParamList.forEach((param: string) => {
        apiParams[param] = state?.data?.[parentDataKey ]?.[param] || '';
    });

    const formControlRef = useRef(null); // Note: For providing reference to ErrorControl
    const readOnly =
        control.readOnly ||
        evaluateExpression(control.readOnlyExpression, state?.data, getControlValueFromState(parentDataKey as string, state as State));

    useEffect(() => {
        const errorMessages = validateFormField(
            control,
            data,
            state,
            control?.props?.label,
            dataKey,
            getControlValueFromState(parentDataKey as string, state as State)
        );
        dispatch({ type: 'SET_FIELD_VALIDATION_ERRORS', payload: { dataKey, errorMessages } });

        if (isEmpty(data) && !isEmpty(control.props.defaultValue)) {
            handleControlValueChange({ control, value: control.props.defaultValue, dataKey, parentDataKey, state, dispatch });
        }
    }, []);

    
    const loadOptions = async (inputValue: string) => {
        if (isEmpty(inputValue) || inputValue.length <= 2) {
            return [];
        }
        try {
            const response = await axiosClient().get(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/autocomplete/${control.props?.customProperties?.autoCompleteApiUrl}?s=${inputValue}&${new URLSearchParams(apiParams)}`
            );
            const optionData = response.data || [];

            return optionData.map((option: any) => ({
                value: option.id,
                label: option.displayValue
            }));
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const getAutoCompleteControl = () => {
        return (
            <>
                <AsyncSelect
                    className={`form-control p-0`}
                    required={control.props?.required}
                    isClearable={true}
                    onChange={(option) => {
                        // setSelectedId(option?.id);
                        setSelectedOptions(option);
                        handleControlValueChange({ control, value: option?.value || "", dataKey, parentDataKey, state, dispatch })
                    }}
                    components={{
                        DropdownIndicator: null,
                        IndicatorSeparator: null
                    }}
                    loadOptions={loadOptions}
                    placeholder={control.props?.placeholder}
                    value={selectedOptions}
                    isDisabled={readOnly ?? false}
                    ref={formControlRef}
                />
            </>
        );
    };

    return (
        <>
            {control.props?.label && (
                <label htmlFor={control.id} className="form-label w-100">
                    {`${control.props.label} `}
                </label>
            )}
            {control?.props?.icon && (
                <div className="input-group mb-3">
                    <span className="input-group-text">
                        <i className={control.props?.icon}></i>
                    </span>
                    {getAutoCompleteControl()}
                </div>
            )}
            {!control.props?.icon && getAutoCompleteControl()}
            <ErrorControl errorMessages={state?.formValidationErrors[dataKey]} />
        </>
    );
};

export default AutoCompleteControl;
